// extracted by mini-css-extract-plugin
module.exports = {"Grid":"CalculatorJsonSummary_Grid__24O5e","Key":"CalculatorJsonSummary_Key__190SR","Value":"CalculatorJsonSummary_Value__1k8Ya"};